/* eslint-disable prettier/prettier */

export default {
  "yesterday": "hier",
  "Something went wrong": "Quelque chose a mal tourné",
  "Try again": "Réessayer",
  "No messages yet": "Pas encore de messages",
  "Your conversations": "Vos conversations",
  "Unread": "Non Lu",
  "Attachment sent": "Pièce jointe envoyée",
  "A call started": "Un appel a commencé",
  "Connecting ...": "Connexion ...",
  "Loading ...": "Chargement ...",
  "All the news you need": "Toute l'actualité dont vous avez besoin",
  "Where and when can you reach us?": "Où et quand pouvez-vous nous joindre?",
  "Experts serving their customers": "Des experts au service de leurs clients",
  "Here you can download the documents": "Ici vous pouvez télécharger les documents",
  "Personal data protection policy": "Politique de protection des données à caractère personnel",
  "Download": "Télécharger",
  "Opening time": "Horaires",
  "Office closed": "Fermé",
  "Sign in / Join": "Connectez-vous / s'inscrire",
  "Recommendations": "Recommandations",
  "Discover our selection of recommendable reading": "Découvrez notre sélection de lecture recommandable",
  "Take part in our discussion forums": "Participe à nos forums de discussions",
  "Post a question": "Poster une question",
  "See more": "Voir plus",
  "Write article": "Rédiger un article",
  "Import a news": "Importer des actualités",
  "All the best events and training in our community": "Tous les meilleurs events et formations de notre communauté",
  "Create Event": "Créer un événement",
  "Images, Videos, PDF, PPT, ... our supports and images at your disposal": "Images, Videos, PDF, PPT,... nos supports et images à votre disposition",
  "Import Medias": "Importer des médias",
  "More infos": "Plus d'infos",
  "Settings": "Paramètres",
  "No activated Survey": "Aucun survey activé",
  "Community": "Communauté",
  "All resources": "Toutes les ressources",
  "Search client...": "Chercher un client...",
  "Loading...": "Chargement...",
  "Search": "Chercher",
  "Purchase invoices": "Factures d'achat",
  "To accept": "A accepter",
  "Forwarded": "Transférées",
  "Booked": "Comptabilisées",
  "Sales invoices": "Factures de vente",
  "Electronic invoices": "Factures électroniques",
  "Clients infos": "Informations clients",
  "Profitability": "Rentabilité",
  "Solvency": "Solvabilité",
  "Liquidity": "Liquidité",
  "No result found": "Aucun résultat trouvé",
  "Selection of useful applications": "Sélectionne d'applications utiles",
  "Letterbox": "Boîte de réception",
  "Empty": "Vide",
  "Received": "Reçu",
  "Not reader": "Non lu",
  "Trash": "Corbeille",
  "All": "Tout",
  "Success": "Succès",
  "Error": "Erreur",
  "Warning": "Avertissement",
  "Layout": "Mise en page",
  "Settings changed successfully": "Paramètres modifiés avec succès",
  "News": "Actualités",
  "Agenda": "Agenda",
  "Join the debate": "Rejoignez le débat",
  "Gallery": "Galerie",
  "Move Up": "Déplacer vers le haut",
  "Move Down": "Déplacer vers le bas",
  "Cancel": "Annuler",
  "Save": "Enregistrer",
  "Saving...": "Enregistrement...",
  "Content Layout": "Mise en page du contenu",
  "Control the layout of the content on your portal here.": "Contrôlez la mise en page du contenu de votre portail",
  "Drawers": "Tiroirs",
  "Manage the drawers that appear on your portal": "Gérez les tiroirs qui apparaissent sur votre portail",
  "Enable": "Activer",
  "Disable": "Désactiver",
  "All fields are required": "Tous les champs sont requis",
  "Add Drawer": "Ajouter un tiroir",
  "Delete": "Supprimer",
  "Enter the name of your drawer ...": "Entrez le nom de votre tiroir ...",
  "Enter the URL of your drawer ...": "Entrez l'URL de votre tiroir ...",
  "You don't have enough permissions to see this page": "Vous n'avez pas assez d'autorisations pour voir cette page",
  "This page is accessible only in 'Community' mode": "Cette page est accessible uniquement en mode 'Communauté'",
  "Invalid URL": "URL invalide",
};



// WEBPACK FOOTER //
// ./src/i18n/fr.js